<template>
  <svg width="27px" height="26px" viewBox="0 0 27 26" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>E6AA66DD-2B3A-40E8-8C68-579C54B945D1OVER</title>
    <g id="Page-Layouts" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" opacity="0.1976609">
      <g id="Profile-EMPTY" transform="translate(-365.000000, -565.000000)">
        <g id="Intro-Block" transform="translate(220.000000, 298.000000)">
          <g id="Social-Links-GRAYED-OUT" transform="translate(40.000000, 267.000000)">
            <g id="linkedin" transform="translate(105.950000, 0.000000)">
              <circle id="Oval" fill="#000000" cx="13" cy="13" r="13"></circle>
              <g id="Group-6" transform="translate(6.909383, 6.379264)">
                <path d="M1.46073897,0 C0.578325773,0 0,0.591262609 0,1.36674087 C0,2.12449391 0.559670103,2.7328487 1.42653691,2.7328487 L1.44332701,2.7328487 C2.34315216,2.7328487 2.90344412,2.12449391 2.90344412,1.36674087 C2.88665402,0.591262609 2.34377402,0 1.46073897,0" id="Fill-4" fill="#202020"></path>
                <path d="M9.34704447,3.5248153 C7.88057554,3.5248153 7.22296317,4.30978922 6.85517996,4.86297183 L6.85517996,4.88959212 L6.83719057,4.88959212 C6.84385331,4.88180081 6.85051605,4.87206168 6.85517996,4.86297183 L6.85517996,3.71505299 L4.09014314,3.71505299 C4.12678821,4.47470516 4.09014314,11.8206066 4.09014314,11.8206066 L6.85517996,11.8206066 L6.85517996,7.29320951 C6.85517996,7.04973125 6.87316936,6.81014864 6.94645949,6.63614284 C7.14700795,6.15308197 7.60207304,5.64924429 8.36495669,5.64924429 C9.36703269,5.64924429 9.76679705,6.39331386 9.76679705,7.48279791 L9.76679705,11.8199573 L12.5318339,11.8199573 L12.5318339,7.17309357 C12.5311676,4.68247328 11.1659723,3.5248153 9.34704447,3.5248153" id="Fill-1" fill="#FFFFFF"></path>
                <polygon id="Fill-7" fill="#FFFFFF" points="0.000124371134 11.707693 2.59118966 11.707693 2.59118966 3.90769299 0.000124371134 3.90769299"></polygon>
              </g>
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
</template>

<script>
export default {
  name: "LinkedInGray"
}
</script>

<style scoped>

</style>